import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IAccountDetail, IAccountFields } from "@/views/account/AccountTypes";
import { accountService } from "@/views/account/AccountService";
import { summaryModel } from "../../customer/summaryModel";

export const accountDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, setLoadingInfo } = useGlobalModel();
    const { detailPartner } = summaryModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountDetail[]>([]);
    //调额弹窗
    const [adjustMonthDrawerVisible, setAdjustMonthDrawerVisible] = useState(false);
    //充值弹窗
    const [rechargeDrawerVisible, setRechargeDrawerVisible] = useState(false);

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onReset = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([]);
    }

    const updateSearchParam = (updateParam: IAccountFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountFields = searchParam) => {
        setLoading(true);
        setDataSource([]);
        const searchParams: IAccountFields = {
            ...searchValue,
            partnerCode: detailPartner,
            shopCode,
            accountTypeCode: 'account-type.credit-month'
        }
        let { retData } = await accountService.find(searchParams);
        setDataSource(retData);

        setLoading(false);
    }


    return {
        /***field***/
        loading,
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedData,
        adjustMonthDrawerVisible,
        rechargeDrawerVisible,
        /***method***/
        setDataSource,
        updateSearchParam,
        loadData,
        setSelectedRowKeys,
        setSelectedData,
        onSearch,
        onReset,
        setAdjustMonthDrawerVisible,
        setRechargeDrawerVisible,
    }
});